import {
  QueryKey,
  QueryObserverOptions,
  useQuery,
} from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { LoadState } from "../enum/loading-state";
import { PagedList, PagedQuery } from "../models/pagination";
import { useUserStore } from "../store/user.store";

export default function usePagedQuery<T>(
  queryKey: QueryKey,
  queryFn: (page: number) => Promise<PagedList<T>>,
  options?: QueryObserverOptions
): PagedQuery<T> {
  const [page, setPage] = useState(0);
  const { fetchStatus, status, data, refetch } = useQuery(
    queryKey.concat([page]),
    () => queryFn(page),
    { ...(options as any), keepPreviousData: true }
  );

  let loadState: LoadState;
  const searchValue = useUserStore((state:any) => state.search);
  const resetPageNumber = useUserStore((state: any) => state.resetPageNumber); // cause a change trigger on the reset page number variable so we can listen on it to reset page number

  if (fetchStatus === "fetching") loadState = LoadState.Loading;
  else {
    switch (status) {
      case "success":
        loadState = LoadState.Success;
        break;

      case "error":
        loadState = LoadState.Error;
        break;

      default:
        loadState = LoadState.Loading;
        break;
    }
  }

  useEffect(() => {
    setPage(0)
  
  }, [searchValue, resetPageNumber])
  

  return {
    status: loadState,
    page,
    setPage,
    result: data ? data : { items: [], totalCount: 0 },
    refetch,
  };
}
